/**
 * Map VWO campaign 27 → rewards_v1 + checklist_v1 on Buybox 2 / Wizard 2.
 * Persist in cookie bz_experiments_v1 and stamp cart attribute _bz_experiments.
 * Wingify owns the split; we no longer coin-flip.
 *
 * Campaign 27 combinations:
 *   1 Control – none          → rewards off, checklist off
 *   2 Rewards only            → rewards on,  checklist off
 *   3 Checklist only          → rewards off, checklist on
 *   4 Rewards + checklist     → rewards on,  checklist on
 */
(function () {
  var ATTR = '_bz_experiments';
  var COOKIE = 'bz_experiments_v1';
  var COOKIE_DAYS = 180;
  var VWO_CAMPAIGN_ID = '27';
  var VWO_COMBI_MAP = {
    '1': { rewards: 'off', checklist: 'off' },
    '2': { rewards: 'on', checklist: 'off' },
    '3': { rewards: 'off', checklist: 'on' },
    '4': { rewards: 'on', checklist: 'on' },
  };
  var lastStamped = '';
  var lastAssigned = '';
  var inflight = null;

  function isAssignmentPage() {
    var body = document.body;
    if (body && body.classList.contains('layout-wizard-2')) return true;
    if (document.getElementById('buybox-2-inline')) return true;
    if (document.querySelector('.buybox-2-inline, [data-buybox-2]')) return true;
    return false;
  }

  function readCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'),
    );
    if (!match) return '';
    try {
      return decodeURIComponent(match[1] || '');
    } catch (e) {
      return String(match[1] || '');
    }
  }

  function writeCookie(name, value, days) {
    var maxAge = Math.max(1, Math.round(Number(days) || COOKIE_DAYS) * 86400);
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      '; path=/; max-age=' +
      maxAge +
      '; SameSite=Lax';
  }

  function parseTokens(raw) {
    return String(raw || '')
      .split(',')
      .map(function (t) {
        return t.trim();
      })
      .filter(function (t) {
        return /^(rewards_v1|checklist_v1):(on|off)$/.test(t);
      });
  }

  function readVwoCombi(campaignId) {
    var raw = readCookie('_vis_opt_exp_' + campaignId + '_combi');
    if (!raw) raw = readCookie('_vis_opt_exp_' + campaignId + '_combi_choose');
    var comb = String(raw || '')
      .trim()
      .split(/[^\d]/)[0] || '';
    return comb;
  }

  function tokensFromVwo() {
    var combi = readVwoCombi(VWO_CAMPAIGN_ID);
    var mapped = combi ? VWO_COMBI_MAP[combi] : null;
    if (!mapped) return '';
    return 'rewards_v1:' + mapped.rewards + ',checklist_v1:' + mapped.checklist;
  }

  /**
   * VWO owns assignment. Never keep a pre-Wingify coin-flip cookie when
   * campaign 27 has not assigned yet (avoids Control still showing punch).
   */
  function assignTokens() {
    var fromVwo = tokensFromVwo();
    if (fromVwo) {
      writeCookie(COOKIE, fromVwo, COOKIE_DAYS);
      if (fromVwo !== lastAssigned) {
        lastAssigned = fromVwo;
        try {
          window.dispatchEvent(new CustomEvent('bz:experiments', { detail: { value: fromVwo } }));
        } catch (e) {}
      }
      return fromVwo;
    }
    // No VWO combi yet — clear sticky cookie so we don't show a stale "on".
    if (readCookie(COOKIE)) {
      writeCookie(COOKIE, '', 0);
      document.cookie = COOKIE + '=; path=/; max-age=0; SameSite=Lax';
    }
    lastAssigned = '';
    return '';
  }

  function readBzExperiments() {
    return assignTokens();
  }

  function stampBzExperiments() {
    if (!isAssignmentPage()) return Promise.resolve('');
    var value = readBzExperiments();
    // Empty = not assigned yet (or Control with no stamp needed); still clear cart attr once.
    if (value === lastStamped) return Promise.resolve(value);
    if (inflight) return inflight;
    var attrs = {};
    attrs[ATTR] = value || '';
    inflight = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attrs }),
    })
      .then(function (res) {
        if (res.ok) lastStamped = value;
        return value;
      })
      .catch(function () {
        return value;
      })
      .finally(function () {
        inflight = null;
      });
    return inflight;
  }

  function rewardsExperimentOn() {
    return /(?:^|,)rewards_v1:on(?:,|$)/.test(readBzExperiments());
  }

  /** Dev helper: force a VWO combi (1–4), sync cookie, reload punch. */
  function forceVwoCombi(combi) {
    var id = String(combi || '').split(/[^\d]/)[0] || '';
    if (!VWO_COMBI_MAP[id]) {
      console.warn('[bz-experiments] use forceVwoCombi(1|2|3|4)');
      return;
    }
    document.cookie =
      '_vis_opt_exp_' + VWO_CAMPAIGN_ID + '_combi=' + id + '; path=/; max-age=86400; SameSite=Lax';
    lastStamped = '';
    stampBzExperiments().then(function (value) {
      console.info('[bz-experiments]', value || '(empty)');
      try {
        window.dispatchEvent(new CustomEvent('bz:experiments', { detail: { value: value } }));
      } catch (e2) {}
    });
  }

  function debugExperiments() {
    return {
      vwoCombi: readVwoCombi(VWO_CAMPAIGN_ID),
      bzCookie: readCookie(COOKIE),
      assigned: assignTokens(),
      rewardsOn: rewardsExperimentOn(),
    };
  }

  window.bzReadExperiments = readBzExperiments;
  window.bzStampExperiments = stampBzExperiments;
  window.bzRewardsExperimentOn = rewardsExperimentOn;
  window.bzForceVwoCombi = forceVwoCombi;
  window.bzDebugExperiments = debugExperiments;

  function boot() {
    if (!isAssignmentPage()) return;
    // VWO SmartCode is async — retry until combi cookie appears.
    var delays = [0, 500, 1000, 2000, 4000, 8000];
    delays.forEach(function (ms) {
      setTimeout(stampBzExperiments, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('pageshow', function () {
    if (isAssignmentPage()) stampBzExperiments();
  });
})();
